<template>
    <div class="secCont">
        <div class="docs_inner">
            <h2 class="secContTit">{{propsHelpContent.title}}</h2>
            <div class="secContInner" v-html='propsHelpContent.contents'>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            propsHelpContent: {
                type:Object
            }
        },
    }
</script>